export const vatMode = () => ({
    marginRight: 80,
});
